import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { PURGE } from "redux-persist";
import { listAccountGroupMasterCustom } from "../../graphql/customQueries";

const INITIAL_STATE = {
  data: [],
  render: true,
  loading: false,
  error: "",
};

export const fetchAccountGroupsMaster = createAsyncThunk(
  "fetchAccountGroupsMaster",
  async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(listAccountGroupMasterCustom)
      );

      return response?.data?.listAccountGroupMaster || [];
    } catch (error) {
      console.error("Error fetching Account Group Master:", error);
      throw error;
    }
  }
);

const accountGroupsMasterSlice = createSlice({
  name: "AccountGroupsMaster",
  initialState: INITIAL_STATE,
  reducers: {
    setRe_RenderGroupsMaster: (state) => {
      state.render = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountGroupsMaster.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchAccountGroupsMaster.pending, (state) => {
        state.loading = true;
        state.render = false;
      })
      .addCase(fetchAccountGroupsMaster.rejected, (state) => {
        state.loading = false;
        state.error = "Something went wrong";
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { setRe_RenderGroupsMaster } = accountGroupsMasterSlice.actions;

export default accountGroupsMasterSlice.reducer;
